import React from "react";
import { Flex, Image, Text, useColorModeValue } from "@chakra-ui/react";
import { useNavigate } from "react-router-dom";

function AccessDenied() {
    const textColor = useColorModeValue("secondaryGray.900", "white");
    const brandColor = useColorModeValue("brand.500", "brand.400");

    const navigate = useNavigate();

    return (
        // <Flex direction="column" align="center" pt={{ sm: "125px", lg: "75px" }}>
        <Flex direction="column" align="center">
            <Image
                src='/access-denied.webp'
                w="500px"
                maxW="90%"
                mt={{ base: "4vh", lg: "15vh" }}
                mb="20px"
                alt="Unauthorized Access"
            />
            <Text
                color={textColor}
                fontSize={{ base: "36px", lg: "42px" }}
                fontWeight="700"
                mb="20px"
                textAlign="center"
            >
                Unauthorized Access.
            </Text>
            <Text
                color={textColor}
                fontSize={{ base: "md", lg: "lg" }}
                fontWeight="500"
                mb="30px"
                textAlign="center"
                maxW="600px"
            >
                You are not allowed to access this page. Click the link below to go to the dashboard.
            </Text>
            <Text
                cursor="pointer"
                color='#fa8f03'
                fontSize={{ base: "md", lg: "lg" }}
                fontWeight="600"
                onClick={() => navigate("/admin/dashboard/overview")}
                textDecoration="underline"
            >
                Go to the dashboard
            </Text>
        </Flex>
    );
}

export default AccessDenied;
